import type { PropsWithChildren, FC } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { TopBar } from '@xing-com/crate-layout-top-bar';
import { useDeviceInfo } from '@xing-com/crate-xinglet';

export const MainLayout: FC<PropsWithChildren> = ({ children }) => {
  const { isWebview } = useDeviceInfo();
  const { isLoggedOut } = useLoginState();

  const type = isLoggedOut ? 'subheaderSearchResults' : 'logo';

  if (isWebview) {
    return <>{children}</>;
  }

  return (
    <>
      <TopBar type={type} hidePlacebo />
      <>{children}</>
    </>
  );
};
